export default "__VITE_ASSET__f786d857__"